module.exports = __webpack_public_path__ + "static/media/craftLove.299cd3b6.jpeg";